import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { WhitelabelImage, WhitelabelImageType } from '@resident-nx/shared';

@Component({
  selector: 'rs-web-whitelabel-image',
  standalone: true,
  templateUrl: './whitelabel-image.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./whitelabel-image.component.scss'],
})
export class WhitelabelImageWebComponent {
  altTag = input<string>();
  whitelabelImage = input<WhitelabelImage>();
  whitelabelImageType = input<WhitelabelImageType>(WhitelabelImageType.PNG);
  onSurface = input(false);
  imageSource = computed(
    () =>
      '/web/images/' +
      this.whitelabelImageType() +
      '/' +
      this.whitelabelImage() +
      '.' +
      this.whitelabelImageType()
  );
}
